import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles<{
  tableHeight?: number
}>()((_, { tableHeight }) => ({
  tableWrapper: {
    maxHeight: tableHeight ? `${tableHeight}px` : "53vh"
  }
}))
